import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { faClose, faTrash } from "@fortawesome/pro-regular-svg-icons";
import { useLingui } from "@lingui/react/macro";
import { getFileTypeIcon } from "../../utils/file-type";
import { Icon } from "../icon";

type TVariant = "default" | "application-form";

interface AttachmentBubbleProps {
  label: string;
  onDelete: () => void;
  deleting?: boolean;
  variant?: TVariant;
}

export function AttachmentBubble({
  variant = "default",
  label,
  deleting,
  onDelete,
}: AttachmentBubbleProps) {
  const { t } = useLingui();
  const attachmentType = label.split(".").pop();

  return (
    <Container variant={variant}>
      {variant === "default" && (
        <Icon icon={getFileTypeIcon(attachmentType!)} width={10} />
      )}
      <Text>{deleting ? t`Deleting...` : label}</Text>
      <Button
        type="button"
        aria-label="delete"
        onClick={onDelete}
        disabled={deleting}
      >
        <Icon
          icon={variant === "application-form" ? faTrash : faClose}
          width={variant === "application-form" ? 12 : 8}
          color={variant === "application-form" ? "purple-100" : "purple-40"}
        />
      </Button>
    </Container>
  );
}

const Container = styled.div<{
  variant: TVariant;
}>`
  align-items: stretch;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.purple[40]};
  border-radius: 8px;
  display: flex;
  align-items: center;
  max-width: 135px;
  text-align: right;
  user-select: none;
  padding: 4px 8px;

  ${(props) =>
    props.variant === "application-form" &&
    css`
      width: 100%;
      max-width: 100%;
      font-size: 14px;
      text-align: center;
      justify-content: center;
      padding: 8px;
      background: ${props.theme.colors.purple[10]};
      border: 0;
    `}
  }
`;

const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 4px;
  margin: auto;
`;

const Button = styled.button`
  -webkit-appearance: none;
  border: 0;
  background: none;
  cursor: pointer;
  padding: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  outline: none;
`;
